import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';  // Assuming you're using react-bootstrap

function ButtonSelect(props) {
    const handleChange = (event) => {
        props.setButton(true);  // Corrected prop name
    };

    return (
        <Button variant={props.variant} onClick={handleChange} className="h-2rem align-items-center justify-content-center" disabled={props.disable}>{props.text.trim()} </Button>  // Corrected prop name
    );
}

ButtonSelect.propTypes = {
    text: PropTypes.string.isRequired,
    setButton: PropTypes.func.isRequired,  // Corrected prop name
    variant: PropTypes.string.isRequired,  // Corrected prop name
}

export default ButtonSelect;